module.exports = __webpack_public_path__ + "img/icon-modal-close.7beb5c31.svg";